<style lang="scss" scoped>
.picker {
  position: fixed;
  bottom: 10px;
  left: 0;
  text-align: left;
  white-space: normal;
  z-index: 1;
}

.btn-send {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-radius: 0;
  color: #b8bfc5;

  &:hover {
    color: $gray-900;
    background-color: rgba(0, 0, 0, 0.1);
  }
}

@media (max-width: 599px) {
  .picker {
    width: 100% !important;
  }
}

@media (min-width: 600px) {
  .picker {
    position: absolute;
    bottom: 10px;
    right: 10px;
    left: unset;

    &-wrapper {
      position: relative;
    }
  }
}
</style>

<template>
  <div class="picker-wrapper">
    <div @click="togglePicker()" class="btn btn-send">
      <i class="far fa-smile"></i>
    </div>
    <picker
      v-show="showPicker"
      class="picker"
      :showSkinTones="false"
      @select="emit"
      :i18n="{
        search: 'Suchen',
        categories: { search: 'Ergebnis der Suche', recent: 'Letzte' }
      }"
      ref="picker"
    />
  </div>
</template>

<script>
import { Picker } from "emoji-mart-vue";
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
  components: {
    Picker
  },
  data() {
    return {
      showPicker: false,
      wait: false,
      timeOutId: null
    };
  },
  methods: {
    togglePicker() {
      this.showPicker = !this.showPicker;
      clearTimeout(this.timeOutId);
      if (this.showPicker) {
        this.wait = true;
        this.timeOutId = setTimeout(() => {
          this.wait = false;
        }, 100);
      }
    },
    emit(event) {
      this.$emit("select", event);
      this.togglePicker();
    }
  },
  mounted() {
    catchOutsideClicks(this.$refs.picker.$el, () => {
      if (!this.wait) {
        this.showPicker = false;
      }
    });
  }
};
</script>
